module.exports = __webpack_public_path__ + "static/media/CL 20.406357d1.mp3";